module.exports = __webpack_public_path__ + "img/202412_flora_04.b95ab090.jpg";